import * as React from 'react'
import styled, { css } from 'styled-components'
import * as Redux from 'react-redux'

import * as plume from '@ulule/owl-kit-components/next'

import * as api from '@owl-nest/api-client/latest'
import * as services from '@owl-nest/services'
import { t } from '@owl-nest/localize'

import { useDisplayMode } from '../../../hooks/useDisplayMode'
import { RootState } from '../../../../reducers'
import * as projectModel from '../../../models/project'

type LikeProps = {
  handleLike: (user: api.AuthenticatedUser<any>) => void
}

const Connect = React.lazy(async () => ({
  default: (await import('@owl-nest/connect')).Connect,
})) as typeof import('@owl-nest/connect').Connect

export function Like({ handleLike }: LikeProps): React.ReactElement<LikeProps> {
  // On utilise une ref ici parce que lorsque les fonctions sont passées à Connect
  // elles ne se re-render pas et l'auth n'est plus à jour
  // il faut donc forcer l'utilisation du onLoggedIn neuf
  const handlersRef = React.useRef({
    handleLike,
  })
  handlersRef.current = {
    handleLike,
  }
  const auth = services.user.useAuth()

  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  const displayMode = useDisplayMode(project)

  return (
    <Wrapper $loggedinUser={auth.type === 'loggedin'}>
      <ConnectWrapper>
        <React.Suspense fallback={<plume.Spinner />}>
          <Connect
            compactMode={true}
            allowGuest={true}
            onGuestLoggedIn={(user) => {
              if (handlersRef.current.handleLike) {
                handlersRef.current.handleLike(user)
              }
            }}
            onLoggedIn={(user) => {
              if (handlersRef.current.handleLike) {
                handlersRef.current.handleLike(user)
              }
            }}
            onSignedUp={(user) => {
              if (handlersRef.current.handleLike) {
                handlersRef.current.handleLike(user)
              }
            }}
            translations={{
              unknownGuestUser: {
                cta: t('Remind me'),
              },
              existingUser: {
                cta: t('Remind me'),
              },
            }}
          />
        </React.Suspense>
      </ConnectWrapper>

      {auth.type === 'loggedin' && (
        <plume.Button
          disabled={displayMode === 'preview'}
          onClick={() => {
            if (auth.type === 'loggedin') {
              handleLike(auth.user)
            }
          }}
        >
          {t('Remind me')}
        </plume.Button>
      )}
    </Wrapper>
  )
}

const ConnectWrapper = styled.div``

const Wrapper = styled.div<{ $loggedinUser: boolean }>`
  padding: 16px;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    padding: 34px;
  }

  ${({ $loggedinUser }) => {
    if ($loggedinUser) {
      return css`
        display: flex;
        flex-direction: column;

        ${ConnectWrapper} {
          margin-bottom: 16px;
        }

        @media screen and ${plume.BREAKPOINTS.LAPTOP} {
          margin-bottom: 33px;
          flex-direction: row;

          ${ConnectWrapper} {
            flex: 2;
            margin-bottom: 0px;
            margin-right: 5px;
          }

          ${plume.styles.button.CallToAction} {
            flex: 1;
          }
        }
      `
    }
  }}
`
